/* eslint-disable */
import createIcon from '../createIcon';

const IconCloseCircleOutlined = createIcon({
  name: 'icon-close-circle-outlined',
  content: '<path d="M514.23 944.348a446.049 446.049 0 01-318.606-760.194A446.049 446.049 0 01512.956 52.251 446.049 446.049 0 01959.004 498.3a446.049 446.049 0 01-446.048 446.048zm0-828.375a382.327 382.327 0 000 764.654A382.327 382.327 0 00896.558 498.3 382.327 382.327 0 00514.23 115.973z"/><path d="M669.073 689.91L307.39 330.713l44.924-45.242 361.681 359.324z"/><path d="M713.486 330.076L354.29 691.758l-45.242-44.924 359.324-361.682z"/>',
  width: 1024,
  height: 1024
});
export default IconCloseCircleOutlined;
